//---------------[NODE MODULES WITH SETTINGS]---------------//


//---------------[GLOBAL VARIABLES]---------------//
//[project info]
export const ProjectName = /innsamling-tutti/;
export const ProjectUrl = process.env.REACT_APP_PUBLIC_URL || "https://www.dugnad.org/";


//[roles]
export const managerRoles = [
  "campaign_admin",
  "manager_admin",
];//from least to most weight


//[image formats]
export const imageFormats = [
  "png", "jpg", "jpeg", "webp",
  "image/png", "image/jpg", "image/jpeg", "image/webp",
];
//[image sizes]


//---------------[REGEX]----------------//
//[url] website url
export const regEx_url = /(https?:\/\/(?:(www\.)|(?!www))[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|www\.[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|https?:\/\/(?:(www\.)|(?!www))[a-zA-Z\d]+\.\S{2,}|www\.[a-zA-Z\d]+\.\S{2,}|^(?:(www\.)|(?!www\.))[a-zA-Z\d]+\.\S{2,}$)/i;
//also allows empty string
export const regEx_urlEmpty = /(https?:\/\/(?:(www\.)|(?!www))[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|www\.[a-zA-Z\d][a-zA-Z\d-]+[a-zA-Z\d]\.\S{2,}|https?:\/\/(?:(www\.)|(?!www))[a-zA-Z\d]+\.\S{2,}|www\.[a-zA-Z\d]+\.\S{2,}|^(?:(www\.)|(?!www\.))[a-zA-Z\d]+\.\S{2,}$)|(^$)/i;

//[username] phone number or email address
export const regEx_username = /((\+)?\d+)|(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$)/;

//[email] email address
export const regEx_email = /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$)/;
export const regEx_emailEmpty = /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$)|(^$)/;
